
function toAnchor(anchorId) {
  anchorId = anchorId.replace('#','');
  const element = document.querySelector('[id="' + anchorId + '"], [name="' + anchorId + '"], [data-id="' + anchorId + '"]');
  toElement(element);
}

function toElement(element) {
  if (element !== null && typeof element !== 'undefined' && element.type !== 'undefined') {
    const topPos = element.getBoundingClientRect().top + window.pageYOffset - document.querySelector('.header').offsetHeight;
    window.scrollTo({
      top: topPos,
      behavior: 'smooth'
    })
  }
}

// scroll to hash on load
if (window.location.hash) {
  toAnchor(window.location.hash.replace('#',''));
}

// scroll to hash link on click
document.querySelectorAll('a[href^="#"]').forEach(item => {
  item.addEventListener('click', event => {
    toAnchor(item.getAttribute('href').replace('#',''));
    event.preventDefault();
    return false;
  })
});

export { toAnchor, toElement }